import { useState, useEffect } from 'react';
import api from '../api';
import { getError } from '../util/index';

const useLouveApi = (url, params) => {
  const [data, setData] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [resError, setResError] = useState();
  
  useEffect(() => {
    try {
      const getData = async () => {
        setIsFetching(true)
        const { data } = params ? await api.get(url, params) : await api.get(url);
        setData(data);
        setIsFetching(false);
      }
      getData();
    } catch (error) {
      setIsFetching(false);
      setResError(error);
      getError(error);
    }
  }, [params, url])

  return { data, isFetching, resError }
}

export { useLouveApi }
